// Safe date parsing utility
export const parseDate = (dateValue: string | Date | any | undefined | null): Date => {
  if (!dateValue) return new Date();
  
  if (dateValue instanceof Date) {
    return isNaN(dateValue.getTime()) ? new Date() : dateValue;
  }
  
  // Handle Firestore Timestamp objects
  if (typeof dateValue === 'object' && 'seconds' in dateValue) {
    return new Date(dateValue.seconds * 1000);
  }
  
  const parsed = new Date(dateValue);
  return isNaN(parsed.getTime()) ? new Date() : parsed;
};

// Calculate days between dates safely
export const calculateDays = (startDate: string | Date | undefined, endDate: string | Date | undefined): number => {
  const start = parseDate(startDate);
  const end = parseDate(endDate);
  const diffTime = end.getTime() - start.getTime();
  return Math.max(1, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
};

// Format date for display
export const formatDate = (dateValue: string | Date | undefined): string => {
  const date = parseDate(dateValue);
  return date.toLocaleDateString();
};

// Format date and time for display
export const formatDateTime = (dateValue: string | Date | undefined): string => {
  const date = parseDate(dateValue);
  return date.toLocaleString();
};

// Check if date is valid
export const isValidDate = (dateValue: string | Date | undefined): boolean => {
  if (!dateValue) return false;
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  return !isNaN(date.getTime());
};
